export const tqe_q1_2 = [
  {
    label: 'How often do you complete your trackers and questionnaires?',
    value: 1,
  }, {
    label: 'Which are you more likely to complete?',
    value: 2,
  },
]

export const answers_q1 = [
  {
    label: 'Always',
    value: 1,
  }, {
    label: 'Often',
    value: 2,
  }, {
    label: 'Sometimes',
    value: 3,
  }, {
    label: 'Rarely',
    value: 4,
  }, {
    label: 'Never',
    value: 5,
  },
]

export const answers_q2 = [
  {
    label: 'Monthly questionnaires ',
    value: 1,
  }, {
    label: 'Daily/weekly trackers',
    value: 2,
  }, {
    label: 'I complete both the questionnaires and trackers ',
    value: 3,
  },
]

export const tqe_q3a = [
  {
    label: 'What motivates you to complete daily/weekly trackers? (Check all that apply) ',
    value: 1,
  },
]

export const answers_q3a = [
  {
    label: 'I get reminders or notifications',
    value: 1,
  }, {
    label: 'I like seeing how I’m doing over time',
    value: 2,
  }, {
    label: 'The information helps inform my care',
    value: 3,
  }, {
    label: 'It doesn’t take much time to complete them',
    value: 4,
  }, {
    label: 'Other (please specify)',
    value: 5,
  },
]

export const tqe_q3b = [
  {
    label: 'What motivates you to complete monthly questionnaires? (Check all that apply)',
    value: 1,
  },
]

export const answers_q3b = [
  {
    label: 'I get reminders or notifications',
    value: 1,
  }, {
    label: 'I like seeing how I’m doing over time',
    value: 2,
  }, {
    label: 'The information helps inform my care',
    value: 3,
  }, {
    label: 'It doesn’t take much time to complete them',
    value: 4,
  }, {
    label: 'Other (please specify)',
    value: 5,
  },
]

export const tqe_q4a = [
  {
    label: 'What makes it harder for you to complete daily/weekly trackers? (Check all that apply)',
    value: 1,
  },
]

export const answers_q4a = [
  {
    label: 'I forget to complete them',
    value: 1,
  }, {
    label: 'There are too many of them',
    value: 2,
  }, {
    label: 'The platform doesn’t work or glitches',
    value: 3,
  }, {
    label: 'There isn’t a mobile app available to complete them',
    value: 4,
  }, {
    label: 'I feel unmotivated because I don’t understand the purpose of the trackers',
    value: 5,
  }, {
    label: 'Other (please specify)',
    value: 6,
  },
]

export const tqe_q4b = [
  {
    label: 'What makes it harder for you to complete monthly questionnaires? (Check all that apply)',
    value: 1,
  },
]

export const answers_q4b = [
  {
    label: 'I forget to complete them',
    value: 1,
  }, {
    label: 'There are too many of them',
    value: 2,
  }, {
    label: 'The platform doesn’t work or glitches',
    value: 3,
  }, {
    label: 'There isn’t a mobile app available to complete them',
    value: 4,
  }, {
    label: 'I feel unmotivated because I don’t understand the purpose of the questionnaires',
    value: 5,
  }, {
    label: 'Other (please specify)',
    value: 6,
  },
]

export const tqe_q5_6 = [
  {
    label: 'What would make it easier or more motivating for you to fill out your trackers and questionnaires? ',
    value: 5,
  }, {
    label: 'Any other comments or suggestions?',
    value: 6,
  },
]
